module.exports = __webpack_public_path__ + "img/g-paper-clicks-logo.a456a624.svg";